export default __webpack_public_path__ + "static/media/building_management.89a4a0c8.PNG";